import React from 'react';
import { Form, Row, Col, Input, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const OtherInfo = ({ initialValues, onMove, onSubmitPayload }) => {
  const onFinish = (values) => {
    onSubmitPayload(3, values);
  };

  return (
    <Form
      name="basic"
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      initialValues={initialValues || { other_info: '' }}
    >
      <Row gutter={32}>
        <Col xl={24}>
          <Form.Item
            label="Other Necessary Information (Optional)"
            name="other_info"
            className="form-item"
          >
            <Input.TextArea size="large" placeholder="Type here ..." />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="space-evenly" className="mt-60">
        <Col xl={8}>
          <Button
            className="default-primary-btn"
            type="primary"
            onClick={() => onMove(2)}
            icon={<ArrowLeftOutlined />}
          >
            Back
          </Button>
        </Col>
        <Col xl={12} />
        <Col xl={4}>
          <Button
            htmlType="submit"
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default OtherInfo;
